import angular from 'angular'
import toolboxComponent from './toolbox.component'

// TODO: this is not a proper component because the controller works on the
// story object - refactor that out to a pub/sub point on the service
//

export default angular
  .module('ellipsis.toolbox', [])
  .component('toolbox', toolboxComponent)
